import { render, staticRenderFns } from "./TipoManutencaoIBPForm.vue?vue&type=template&id=ec8f9ab0"
import script from "./TipoManutencaoIBPForm.vue?vue&type=script&lang=js"
export * from "./TipoManutencaoIBPForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports